// src/services/moderationService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function fetchPendingExperiments() {
    return apiRequest(endpoints.pendingSubmissions);
}

export function moderateExperiment(id, action) {
    return apiRequest(endpoints.moderation(id, action), {
        method: 'POST',
    });
}

// `statuses` (optional array, e.g. ['PENDING', 'NEEDS_UPDATE']) scopes the
// query server-side so a page like Moderation Queue never fetches
// approved/rejected records at all. Omitted entirely, it returns everything.
export function fetchAllExperiments(page = 0, size = 25, statuses) {
    const url = new URL(endpoints.allSubmissions, window.location.origin);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (statuses && statuses.length > 0) {
        statuses.forEach((s) => url.searchParams.append('statuses', s));
    }
    return apiRequest(url.toString());
}

export function fetchModerationStats() {
    return apiRequest(endpoints.moderationStats);
}

export function updateExperimentStatus(id, newStatus, comment = '') {
    // Construct the URL with query parameters
    const url = new URL(endpoints.updateStatus(id), window.location.origin);
    url.searchParams.append('newStatus', newStatus);
    if (comment) {
        url.searchParams.append('comment', comment);
    }

    return apiRequest(url.toString(), {
        method: 'POST',
    });
}

export function deleteExperimentPermanently(id) {
    return apiRequest(endpoints.deleteRecord(id), {
        method: 'DELETE',
    });
}

export function bulkUpdateExperimentStatus(ids, newStatus, comment = '') {
    const url = new URL(endpoints.bulkUpdateStatus, window.location.origin);
    url.searchParams.append('newStatus', newStatus);
    if (comment) {
        url.searchParams.append('comment', comment);
    }

    return apiRequest(url.toString(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(ids)
    });
}
